<template>
    <v-btn :id="id" :class="ClassProps" :style="styleProp" :loading="loading" :color="color" :block="block" :outlined="outlined" :disabled="disable" @click="click" :text="text">
        <slot/>
    </v-btn>
</template>

<script>
export default {
    props:
    {
        id:
        {
            required:false,
            default:""
        },  
        styleProp:
        {
            type:String,
            required:false
        },
        outlined:
        {
            type:Boolean,
            required:false,
            default:false
        },
        block:
        {
            type:Boolean,
            required:false,
            default:false
        },
        color:
        {
            type:String,
            default:"primary"
        },
        click:
        {
            type:Function,
            required:false,
            default:()=>{}
        },
        disable:
        {
            type:Boolean,
            required:false
        },
        loading:
        {
            type:Boolean,
            required:false
        },
        text:
        {
            type:Boolean,
            required:false,
            default:false
        },
        ClassProps:
        {
            type:String,
            default:"primary-button",
            required:false
        }
    }
}
</script>

<style scoped>
.primary-button
{
    height: 57px !important;
    width: 218px;
    font-size: 19px;
}

</style>